import { Injectable } from '@angular/core';
import { ODataQueryState } from '../types/odata-query-state';
import { Filter } from 'odata-query';

@Injectable()
export class PrimeGridFilterBuilderService<TData> {
  private setting: ODataQueryState<TData> = {};
  private defaultSetting: ODataQueryState<TData> = {};

  get skipValue(): number {
    return this.setting.skip!;
  }

  get topValue(): number {
    return this.setting.top!;
  }

  init(initSetting: ODataQueryState<TData>): void {
    this.setting = initSetting;
    this.defaultSetting = { ...initSetting };
  }

  orderBy(orderBy: string): PrimeGridFilterBuilderService<TData> {
    if (orderBy) {
      this.setting.orderBy = orderBy;
    }

    return this;
  }

  top(top: number): PrimeGridFilterBuilderService<TData> {
    this.setting.top = top;
    return this;
  }

  skip(skip: number): PrimeGridFilterBuilderService<TData> {
    this.setting.skip = skip;
    return this;
  }

  filter(filter: Filter<TData>): PrimeGridFilterBuilderService<TData> {
    this.setting.filter = filter;
    return this;
  }

  getValue(): ODataQueryState<TData> {
    return { ...this.setting };
  }

  reset(): void {
    this.setting = { ...this.defaultSetting };
  }

  merge(
    rightSource: ODataQueryState<TData>
  ): PrimeGridFilterBuilderService<TData> {
    const filter = this.setting.filter;
    if (filter) {
      Object.assign(filter, rightSource.filter);
    }

    Object.assign(this.setting, rightSource);

    if (filter) {
      this.setting = {
        ...this.setting,
        filter,
      };
    }

    return this;
  }
}
